import { Grid } from '@alifd/next';

export default Grid;
